export default { SIGNIN: 'signIn', SIGNEDIN: 'signedIn', LOADING: 'loading' };